<template>
  <CContainer class="pt-5 mb-5" fluid>
    <CRow>
      <CCol class="col-12">
        <h3 class="pl-3 mb-0 pb-0">Notaris</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item to="/notaris">
            <CIcon name="cil-balance-scale" />
            Notaris
          </b-breadcrumb-item>
          <b-breadcrumb-item active>Create New</b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CForm>
      <CCard class="custom-form-card custom-card ml-2 mr-2 mb-4">
        <CCardBody>
          <CRow>
            <CCol class="col-md-12 col-lg-6">
              <CRow>
                <CCol class="col-12 pb-1">
                  <h5 class="custom-header">User</h5>
                  <CRow>
                    <!-- <CCol class="col-12">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="User:"
                        label-for="form-user-user"
                        :state="formData.userUser.isValid"
                      >
                        <multiselect 
                          v-model="formData.userUser.value" 
                          :options="formData.userUser.options" 
                          :state="formData.userUser.isValid"
                          :class="{custom_multiselect_invalid: formData.userUser.isValid === false}"
                          id="form-user-user"
                          placeholder="Select an option"
                          :showLabels="false"
                          :loading="!formData.userUser.isLoaded"
                          openDirection="bottom"
                          label="fullName"
                          track-by="id"
                          :internalSearch="false"
                          :preserveSearch="true"
                          @input="clearUser"
                          @search-change="populateSelectUser"
                        >
                          <template slot="singleLabel" slot-scope="props">{{ props.option.fullName }}</template>
                          <template slot="option" slot-scope="props">{{ props.option.fullName }}</template>
                          <template slot="noResult">No elements found.</template>
                          <template slot="afterList" v-if="formData.userUser.currentPage < formData.userUser.totalPages">
                            <div class="text-center custom-cursor-clickable p-2" @click="appendSelectUser" v-if="formData.userUser.isLoaded">
                              <span class="text-muted">Load More</span>
                            </div>
                            <div class="text-center" v-else>
                              <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                            </div>
                          </template>
                        </multiselect>
                      </b-form-group>
                    </CCol> -->
                    <CCol class="col-12">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="Full Name:"
                        label-for="form-user-fullname"
                        :state="formData.userFullName.isValid"
                      >
                        <b-form-input
                          v-model="formData.userFullName.value"
                          :state="formData.userFullName.isValid"
                          maxlength="240"
                          placeholder="Full Name"
                          id="form-user-fullname"
                          :disabled="formData.userUser.value.id !== -1"
                        ></b-form-input>
                      </b-form-group>
                    </CCol>
                    <!-- <CCol class="col-12">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="Job Code:"
                        label-for="form-user-jobcode"
                        :state="formData.userJobCode.isValid"
                      >
                        <multiselect 
                          v-model="formData.userJobCode.value" 
                          :options="formData.userJobCode.options" 
                          :state="formData.userJobCode.isValid"
                          :class="{custom_multiselect_invalid: formData.userJobCode.isValid === false}"
                          id="form-user-jobcode"
                          :disabled="formData.userUser.value.id !== -1"
                          placeholder="Select an option"
                          :showLabels="false"
                          :loading="!formData.userJobCode.isLoaded"
                          openDirection="bottom"
                          label="jobName"
                          track-by="jobCode"
                          :internalSearch="false"
                          :preserveSearch="true"
                          @search-change="populateSelectJobCode"
                        >
                          <template slot="singleLabel" slot-scope="props">{{ props.option.jobName }}</template>
                          <template slot="option" slot-scope="props">{{ props.option.jobName }}</template>
                          <template slot="noResult">No elements found.</template>
                          <template slot="afterList" v-if="formData.userJobCode.currentPage < formData.userJobCode.totalPages">
                            <div class="text-center custom-cursor-clickable p-2" @click="appendSelectJobCode" v-if="formData.userJobCode.isLoaded">
                              <span class="text-muted">Load More</span>
                            </div>
                            <div class="text-center" v-else>
                              <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                            </div>
                          </template>
                        </multiselect>
                      </b-form-group>
                    </CCol> -->
                    <CCol class="col-6">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="Username:"
                        label-for="form-user-name"
                        :state="formData.userName.isValid"
                      >
                        <b-form-input
                          v-model="formData.userName.value"
                          :state="formData.userName.isValid"
                          maxlength="50"
                          placeholder="Username"
                          id="form-user-name"
                          :disabled="formData.userUser.value.id !== -1"
                        ></b-form-input>
                      </b-form-group>
                    </CCol>
                    <CCol class="col-6">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="Tipe"
                        label-for="form-type"
                        :state="formData.type.isValid"
                      >
                        <multiselect 
                          v-model="formData.type.value" 
                          :options="formData.type.options" 
                          :state="formData.type.isValid"
                          :class="{custom_multiselect_invalid: formData.type.isValid === false}"
                          :searchable="false"
                          id="form-type"
                          placeholder="Select an option"
                          :showLabels="false"
                          openDirection="bottom"
                          label="text"
                          track-by="value"
                        >
                          <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                          <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                        </multiselect>
                      </b-form-group>
                    </CCol>
                    <CCol class="col-6">
                      <b-form-group
                        :invalid-feedback="formData.userPword.feedback"
                        label="Password:"
                        label-for="form-user-pword"
                        :state="formData.userPword.isValid"
                      >
                        <b-form-input
                          v-model="formData.userPword.value"
                          :state="formData.userPword.isValid"
                          maxlength="50"
                          type="password"
                          placeholder="Password"
                          id="form-user-pword"
                          :disabled="formData.userUser.value.id !== -1"
                        ></b-form-input>
                      </b-form-group>
                    </CCol>
                    <CCol class="col-6">
                      <b-form-group
                        invalid-feedback="Password does not match."
                        label="Confirm Password:"
                        label-for="form-user-cpword"
                        :state="formData.userCPword.isValid"
                      >
                        <b-form-input
                          v-model="formData.userCPword.value"
                          :state="formData.userCPword.isValid"
                          maxlength="50"
                          type="password"
                          placeholder="Confirm Password"
                          id="form-user-cpword"
                          :disabled="formData.userUser.value.id !== -1"
                        ></b-form-input>
                      </b-form-group>
                    </CCol>
                  </CRow>
                  <!-- <h5 class="custom-header">Vendor & Cabang</h5>
                  <CRow>
                    <CCol class="col-7">
                      <b-form-group
                        :invalid-feedback="formData.vendorId.feedback"
                        valid-feedback="Vendor ID is available."
                        label="Vendor ID"
                        label-for="form-vendor-id"
                        :state="formData.vendorId.isValid"
                      >
                        <b-input-group>
                          <b-form-input
                            autofocus
                            v-model="formData.vendorId.value"
                            :state="formData.vendorId.isValid"
                            placeholder="Vendor ID"
                            id="form-vendor-id"
                            @input="clearFormVendor"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-button
                              variant="primary"
                              :disabled="formData.vendorId.isChecking || formData.vendorId.isValid"
                              @click="validateVendorId"
                              style="width:4.5rem"
                            >
                              <b-spinner small v-if="formData.vendorId.isChecking" />
                              <span v-else>Check</span>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </CCol>
                    <CCol class="col-5">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="Tipe"
                        label-for="form-type"
                        :state="formData.type.isValid"
                      >
                        <multiselect 
                          v-model="formData.type.value" 
                          :options="formData.type.options" 
                          :state="formData.type.isValid"
                          :class="{custom_multiselect_invalid: formData.type.isValid === false}"
                          :searchable="false"
                          id="form-type"
                          placeholder="Select an option"
                          :showLabels="false"
                          openDirection="bottom"
                          label="text"
                          track-by="value"
                        >
                          <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                          <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                        </multiselect>
                      </b-form-group>
                    </CCol>
                    <CCol class="col-12">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="Office"
                        label-for="form-office"
                        :state="formData.office.isValid"
                      >
                        <multiselect 
                          v-model="formData.office.value" 
                          :options="formData.office.options" 
                          :state="formData.office.isValid"
                          :class="{custom_multiselect_invalid: formData.office.isValid === false}"
                          id="form-office"
                          placeholder="Select an option"
                          :showLabels="false"
                          :loading="!formData.office.isLoaded"
                          openDirection="bottom"
                          label="nameFull"
                          track-by="officeCode"
                          :internalSearch="false"
                          :preserveSearch="true"
                          @search-change="populateSelectOffice"
                        >
                          <template slot="singleLabel" slot-scope="props">{{ props.option.nameFull }}</template>
                          <template slot="option" slot-scope="props">{{ props.option.nameFull }}</template>
                          <template slot="noResult">No elements found.</template>
                          <template slot="afterList" v-if="formData.office.currentPage < formData.office.totalPages">
                            <div class="text-center custom-cursor-clickable p-2" @click="appendSelectOffice" v-if="formData.office.isLoaded">
                              <span class="text-muted">Load More</span>
                            </div>
                            <div class="text-center" v-else>
                              <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                            </div>
                          </template>
                        </multiselect>
                      </b-form-group>
                    </CCol>
                    <CCol class="col-12">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="Kuota Kontrak:"
                        label-for="form-contract-quota"
                        :state="formData.contractQuota.isValid"
                      >
                        <b-form-input
                          :value="$helper.thousandSeparator(formData.contractQuota.value)"
                          @input="formData.contractQuota.value = $event.toString().replace(/\./g, '')"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 13"
                          :state="formData.contractQuota.isValid"
                          placeholder="Kuota Kontrak"
                          type="text"
                          id="form-contract-quota"
                        ></b-form-input>
                      </b-form-group>
                    </CCol>
                  </CRow> -->
                </CCol>
                <CCol class="col-12 pt-1">
                  <h5 class="custom-header">NPWP, Jamsostek, & SKB</h5>
                  <CRow>
                    <CCol class="col-6">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="No. NPWP:"
                        label-for="form-npwp-no"
                        :state="formData.npwpNo.isValid"
                      >
                        <b-form-input
                          :value="formData.npwpNo.value"
                          @input="formData.npwpNo.value = $helper.parseNpwp($event)"
                          onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 45 || event.charCode == 46"
                          maxlength="20"
                          :state="formData.npwpNo.isValid"
                          placeholder="00.000.000.0-000.000"
                          id="form-npwp-no"
                        ></b-form-input>
                      </b-form-group>
                    </CCol>
                    <CCol class="col-6">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="Jamsostek ID"
                        label-for="form-jst-id"
                        :state="formData.jstId.isValid"
                      >
                        <b-form-input
                          v-model="formData.jstId.value"
                          :state="formData.jstId.isValid"
                          maxlength="50"
                          placeholder="Jamsostek ID"
                          id="form-jst-id"
                        ></b-form-input>
                      </b-form-group>
                    </CCol>
                    <CCol class="col-12">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="Nama NPWP:"
                        label-for="form-npwp-name"
                        :state="formData.npwpName.isValid"
                      >
                        <b-form-input
                          v-model="formData.npwpName.value"
                          :state="formData.npwpName.isValid"
                          maxlength="60"
                          placeholder="Nama NPWP"
                          id="form-npwp-name"
                        ></b-form-input>
                      </b-form-group>
                    </CCol>
                    <CCol class="col-12">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="Alamat NPWP:"
                        label-for="form-npwp-address"
                        :state="formData.npwpAddress.isValid"
                      >
                        <b-form-textarea
                          v-model="formData.npwpAddress.value"
                          :state="formData.npwpAddress.isValid"
                          maxlength="160"
                          placeholder="Alamat NPWP"
                          id="form-npwp-address"
                          rows="3"
                          max-rows="3"
                        ></b-form-textarea>
                      </b-form-group>
                    </CCol>
                    <CCol class="col-6">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="SKB"
                        label-for="form-skb"
                        :state="formData.skb.isValid"
                      >
                        <multiselect 
                          v-model="formData.skb.value" 
                          :options="formData.skb.options" 
                          :state="formData.skb.isValid"
                          :class="{custom_multiselect_invalid: formData.skb.isValid === false}"
                          :searchable="false"
                          id="form-skb"
                          placeholder="Select an option"
                          :showLabels="false"
                          openDirection="bottom"
                          label="text"
                          track-by="text"
                        >
                          <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                          <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                        </multiselect>
                      </b-form-group>
                    </CCol>
                    <CCol class="col-6">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="PPN"
                        label-for="form-ppn"
                        :state="formData.ppn.isValid"
                      >
                        <multiselect 
                          v-model="formData.ppn.value" 
                          :options="formData.ppn.options" 
                          :state="formData.ppn.isValid"
                          :class="{custom_multiselect_invalid: formData.ppn.isValid === false}"
                          :searchable="false"
                          id="form-ppn"
                          placeholder="Select an option"
                          :showLabels="false"
                          openDirection="bottom"
                          label="text"
                          track-by="text"
                        >
                          <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                          <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                        </multiselect>
                      </b-form-group>
                    </CCol>
                    <CCol class="col-12">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="Masa Berlaku SKB:"
                        label-for="form-valid-start"
                        :state="formData.skbValidFrom.isValid"
                      >
                        <b-input-group>
                          <b-form-datepicker
                            v-model="formData.skbValidFrom.value" 
                            :max="formData.skbValidFrom.maxValue"
                            id="form-valid-start"
                            placeholder="DD/MM/YYYY"
                            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                            locale="id"
                            :state="formData.skbValidTo.isValid"
                            :disabled="formData.skb.value.value === true"
                            @context="onContextSkbValidFrom"
                          ></b-form-datepicker>
                          <b-input-group-append>
                            <b-input-group-text>
                              ~
                            </b-input-group-text>
                          </b-input-group-append>
                          <b-form-datepicker
                            v-model="formData.skbValidTo.value" 
                            :min="formData.skbValidTo.minValue"
                            :max="formData.skbValidTo.maxValue"
                            id="form-valid-end"
                            placeholder="DD/MM/YYYY"
                            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                            locale="id"
                            :state="formData.skbValidTo.isValid"
                            :disabled="formData.skb.value.value === true"
                            @context="onContextSkbValidTo"
                          ></b-form-datepicker>
                        </b-input-group>
                      </b-form-group>
                    </CCol>
                  </CRow>
                </CCol>
              </CRow>
            </CCol>
            <CCol class="col-md-12 col-lg-6">
              <h5 class="custom-header">Data Pribadi</h5>
              <CRow>
                <CCol class="col-12">
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Nama:"
                    label-for="form-notary-name"
                    :state="formData.notaryName.isValid"
                  >
                    <b-form-input
                      v-model="formData.notaryName.value"
                      :state="formData.notaryName.isValid"
                      maxlength="70"
                      placeholder="Nama"
                      id="form-notary-name"
                    ></b-form-input>
                  </b-form-group>
                </CCol>
                <CCol class="col-12">
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Tanggal Lahir:"
                    label-for="form-notary-bdate"
                    :state="formData.notaryBdate.isValid"
                  >
                    <b-form-datepicker
                      v-model="formData.notaryBdate.value" 
                      :max="formData.notaryBdate.maxValue"
                      id="form-notary-bdate"
                      placeholder="DD/MM/YYYY"
                      :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                      locale="id"
                      :state="formData.notaryBdate.isValid"
                    ></b-form-datepicker>
                  </b-form-group>
                </CCol>
                <CCol class="col-12">
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Alamat 1:"
                    label-for="form-notary-addr1"
                    :state="formData.notaryAddr1.isValid"
                  >
                  <b-form-textarea
                    v-model="formData.notaryAddr1.value"
                    :state="formData.notaryAddr1.isValid"
                    maxlength="120"
                    placeholder="Alamat 1"
                    id="form-notary-addr1"
                    rows="3"
                    max-rows="3"
                  ></b-form-textarea>
                  </b-form-group>
                </CCol>
                <CCol class="col-12">
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Alamat 2:"
                    label-for="form-notary-addr2"
                    :state="formData.notaryAddr2.isValid"
                  >
                    <b-form-textarea
                      v-model="formData.notaryAddr2.value"
                      :state="formData.notaryAddr2.isValid"
                      maxlength="100"
                      placeholder="Alamat 2"
                      id="form-notary-addr2"
                      rows="3"
                      max-rows="3"
                    ></b-form-textarea>
                  </b-form-group>
                </CCol>
                <CCol class="col-6">
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Kota:"
                    label-for="form-notary-city"
                    :state="formData.notaryCity.isValid"
                  >
                    <multiselect 
                      v-model="formData.notaryCity.value" 
                      :options="formData.notaryCity.options" 
                      class="mb-0"
                      :class="{custom_multiselect_invalid: formData.notaryCity.isValid === false}"
                      placeholder="Select an option"
                      :showLabels="false"
                      :loading="!formData.notaryCity.isLoaded"
                      openDirection="bottom"
                      label="name"
                      track-by="code"
                      :internalSearch="false"
                      :multiple="false"
                      :preserveSearch="false"
                      @search-change="populateCity"
                      @input="onInputCity"
                    >
                      <template slot="singleLabel" slot-scope="props">{{ props.option.name }}</template>
                      <template slot="option" slot-scope="props">{{ props.option.name }}</template>
                      <template slot="noResult">No elements found.</template>
                      <template slot="afterList" v-if="formData.notaryCity.currentPage < formData.notaryCity.totalPages">
                        <div class="text-center custom-cursor-clickable p-2" @click="appendCity" v-if="formData.notaryCity.isLoaded">
                          <span class="text-muted">Load More</span>
                        </div>
                        <div class="text-center" v-else>
                          <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                        </div>
                      </template>
                    </multiselect>
                    <!-- <b-form-input
                      v-model="formData.notaryCity.value"
                      :state="formData.notaryCity.isValid"
                      maxlength="100"
                      placeholder="Kota"
                      id="form-notary-city"
                    ></b-form-input> -->
                  </b-form-group> 
                </CCol>
                <CCol class="col-6">
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Kode Pos:"
                    label-for="form-notary-zip"
                    :state="formData.notaryZip.isValid"
                  >
                    <multiselect 
                      v-model="formData.notaryZip.value" 
                      :options="formData.notaryZip.options" 
                      class="mb-0"
                      :class="{custom_multiselect_invalid: formData.notaryZip.isValid === false}"
                      placeholder="Select an option"
                      :showLabels="false"
                      :loading="!formData.notaryZip.isLoaded"
                      openDirection="bottom"
                      label="name"
                      track-by="code"
                      :internalSearch="false"
                      :multiple="false"
                      :preserveSearch="false"
                      @search-change="populateZipcode"
                      @input="onInputZipcode"
                    >
                      <template slot="singleLabel" slot-scope="props">{{ props.option.name }}</template>
                      <template slot="option" slot-scope="props">{{ props.option.name }}</template>
                      <template slot="noResult">No elements found.</template>
                      <template slot="afterList" v-if="formData.notaryZip.currentPage < formData.notaryZip.totalPages">
                        <div class="text-center custom-cursor-clickable p-2" @click="appendZipcode" v-if="formData.notaryZip.isLoaded">
                          <span class="text-muted">Load More</span>
                        </div>
                        <div class="text-center" v-else>
                          <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                        </div>
                      </template>
                    </multiselect>
                    <!-- <b-form-input
                      :value="formData.notaryZip.value"
                      @input="formData.notaryZip.value = $helper.parseNumber($event)"
                      :key="formData.notaryZip.key"
                      maxlength="5"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      :state="formData.notaryZip.isValid"
                      placeholder="Kode Pos"
                      id="form-notary-zip"
                    ></b-form-input> -->
                  </b-form-group>
                </CCol>
                <CCol class="col-6">
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Telephone 1:"
                    label-for="form-notary-tel1"
                    :state="formData.notaryTel1.isValid"
                  >
                    <b-form-input
                      :value="formData.notaryTel1.value"
                      @input="formData.notaryTel1.value = $helper.parseNumber($event)"
                      :key="formData.notaryTel1.key"
                      maxlength="30"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      :state="formData.notaryTel1.isValid"
                      placeholder="Telephone 1"
                      id="form-notary-tel1"
                    ></b-form-input>
                  </b-form-group>
                </CCol>
                <CCol class="col-6">
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Telephone 2:"
                    label-for="form-notary-tel2"
                    :state="formData.notaryTel2.isValid"
                  >
                    <b-form-input
                      :value="formData.notaryTel2.value"
                      @input="formData.notaryTel2.value = $helper.parseNumber($event)"
                      :key="formData.notaryTel2.key"
                      maxlength="30"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      :state="formData.notaryTel2.isValid"
                      placeholder="Telephone 2"
                      id="form-notary-tel2"
                    ></b-form-input>
                  </b-form-group>
                </CCol>
                <CCol class="col-6">
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Handphone 1:"
                    label-for="form-notary-phone1"
                    :state="formData.notaryPhone1.isValid"
                  >
                    <b-form-input
                      :value="formData.notaryPhone1.value"
                      @input="formData.notaryPhone1.value = $helper.parseNumber($event)"
                      :key="formData.notaryPhone1.key"
                      maxlength="15"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      :state="formData.notaryPhone1.isValid"
                      placeholder="Handphone 1"
                      id="form-notary-phone1"
                    ></b-form-input>
                  </b-form-group>
                </CCol>
                <CCol class="col-6">
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Handphone 2:"
                    label-for="form-notary-phone2"
                    :state="formData.notaryPhone2.isValid"
                  >
                    <b-form-input
                      :value="formData.notaryPhone2.value"
                      @input="formData.notaryPhone2.value = $helper.parseNumber($event)"
                      :key="formData.notaryPhone2.key"
                      maxlength="15"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      :state="formData.notaryPhone2.isValid"
                      placeholder="Handphone 2"
                      id="form-notary-phone2"
                    ></b-form-input>
                  </b-form-group>
                </CCol>
                <CCol class="col-6">
                  <b-form-group
                    :invalid-feedback="formData.notaryEmail.feedback"
                    label="Email:"
                    label-for="form-notary-email"
                    :state="formData.notaryEmail.isValid"
                  >
                    <b-form-input
                      v-model="formData.notaryEmail.value"
                      :state="formData.notaryEmail.isValid"
                      maxlength="50"
                      placeholder="Email"
                      id="form-notary-email"
                    ></b-form-input>
                  </b-form-group>
                </CCol>
                <CCol class="col-6">
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="FAX:"
                    label-for="form-notary-fax"
                    :state="formData.notaryFax.isValid"
                  >
                    <b-form-input
                      :value="formData.notaryFax.value"
                      @input="formData.notaryFax.value = $helper.parseNumber($event)"
                      :key="formData.notaryFax.key"
                      maxlength="30"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      :state="formData.notaryFax.isValid"
                      placeholder="FAX"
                      id="form-notary-fax"
                    ></b-form-input>
                  </b-form-group>
                </CCol>
              </CRow>
            </CCol>
            <!-- <CCol class="col-12 p-1">
              <CCard class="custom-form-card custom-card mb-2">
                <CCardBody>
                  <h5 class="custom-header">User</h5>
                  <CRow>
                    <CCol class="col-md-12 col-lg-6">
                      <CRow>
                      </CRow>
                    </CCol>
                    <CCol class="col-12">
                      <CButton color="primary" class="float-right" style="width:7rem" type="submit" :disabled="isSubmitting" @click="createNotary">
                        <b-spinner small v-if="isSubmitting" />
                        <span v-else>Submit</span>
                      </CButton>
                    </CCol>
                  </CRow>
                </CCardBody>
              </CCard>
            </CCol> -->
            <CCol class="col-12 pt-2 pb-3">
              <CButton color="primary" class="float-right" style="width:7rem" type="submit" :disabled="isSubmitting" @click="createNotary">
                <b-spinner small v-if="isSubmitting" />
                <span v-else>Submit</span>
              </CButton>
              <b-btn variant="secondary" class="mr-2 float-right" @click="$router.push({name: 'Notaris List'})">Cancel</b-btn>
              <!-- <b-btn @click="testAction">Test</b-btn> -->
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CForm>
  </CContainer>
</template>


<script>
export default {
  name: 'NotarisAdd',
  data() {
    const today = this.$moment().format('YYYY-MM-DD')
    const periodFormat = /[0-9]{4}-[0-9]{2}-[0-9]{2}/g
    const emailFormat = /^\S+@\S+\.\S+$/
    return {
      citySelectedfromZipcode: false,
      keyIncrement: 0,
      isSubmitting: false,
      formData: {
        // vendorId: {
        //   value: '',
        //   isChecking: false,
        //   isValid: null,
        //   isRequired: true,
        //   feedback: 'Vendor ID is not valid.',
        //   payloadKey: "vendorId"
        // },
        type: {
          value: '',
          isValid: null,
          isRequired: true,
          // hardcoded options
          options: [
            { value: '1', text: "Badan Usaha" },
            { value: '2', text: "Perorangan" }
          ],
          payloadKey: "type"
        },
        // office: {
        //   /*
        //     "nameFull": "string",
        //     "nameShort": "string",
        //     "officeCode": "string
        //   */
        //   value: '',
        //   isLoaded: false,
        //   isValid: null,
        //   isRequired: true,
        //   options: [],
        //   currentPage: 1,
        //   perPage: 10,
        //   totalRows: 0,
        //   totalPages: 0,
        //   lastQuery: '',
        //   payloadKey: "officeCode"
        // },
        // contractQuota: {
        //   value: '',
        //   isValid: null,
        //   isRequired: true,
        //   payloadKey: "contractQuota"
        // },
        npwpNo: {
          value: '',
          isValid: null,
          isRequired: false,
          payloadKey: "npwpNo"
        },
        jstId: {
          value: '',
          isValid: null,
          isRequired: false,
          payloadKey: "jamsostekId"
        },
        npwpName: {
          value: '',
          isValid: null,
          isRequired: false,
          payloadKey: "npwpName"
        },
        npwpAddress: {
          value: '',
          isValid: null,
          isRequired: false,
          payloadKey: "npwpAddress"
        },
        skb: {
          value: { value: false, text: "True" },
          isValid: null,
          isRequired: true,
          // intentionally reversed
          options: [
            { value: false, text: "True" },
            { value: true, text: "False" }
          ],
          payloadKey: "pph"
        },
        ppn: {
          value: '',
          isValid: null,
          isRequired: true,
          options: [
            { value: true, text: "True" },
            { value: false, text: "False" }
          ],
          payloadKey: "ppn"
        },
        skbValidFrom: {
          value: '',
          isValid: null,
          isRequired: true,
          maxValue: '',
          payloadKey: "nonPphStartdate"
        },
        skbValidTo: {
          value: '',
          isValid: null,
          isRequired: true,
          minValue: '',
          maxValue: '',
          payloadKey: "nonPphEnddate"
        },
        notaryName: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "name"
        },
        notaryBdate: {
          value: '',
          isValid: null,
          isRequired: true,
          maxValue: today,
          payloadKey: "birthDate"
        },
        notaryAddr1: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "address1"
        },
        notaryAddr2: {
          value: '',
          isValid: null,
          isRequired: false,
          payloadKey: "address2"
        },
        notaryCity: {
          value: null,
          options: [],
          isLoaded: false,
          isValid: null,
          isRequired: true,
          payloadKey: "city",
          currentPage: 1,
          perPage: 10,
          totalRows: 0,
          totalPages: 0,
          lastQuery: '',
        },
        notaryZip: {
          value: null,
          options: [],
          isLoaded: false,
          isValid: null,
          key: 'notaryZip-0',
          isRequired: true,
          payloadKey: "zipcode",
          currentPage: 1,
          perPage: 10,
          totalRows: 0,
          totalPages: 0,
          lastQuery: '',
        },
        notaryTel1: {
          value: '',
          isValid: null,
          key: 'notaryTel1-0',
          isRequired: true,
          payloadKey: "tel1"
        },
        notaryTel2: {
          value: '',
          isValid: null,
          key: 'notaryTel2-0',
          isRequired: false,
          payloadKey: "tel2"
        },
        notaryPhone1: {
          value: '',
          isValid: null,
          key: 'notaryPhone1-0',
          isRequired: true,
          payloadKey: "mobile1"
        },
        notaryPhone2: {
          value: '',
          isValid: null,
          key: 'notaryPhone2-0',
          isRequired: false,
          payloadKey: "mobile2"
        },
        notaryFax: {
          value: '',
          isValid: null,
          key: 'notaryFax-0',
          isRequired: false,
          payloadKey: "fax"
        },
        notaryEmail: {
          value: '',
          feedback: 'This input is required.',
          format: emailFormat,
          isValid: null,
          isRequired: true,
          payloadKey: "email"
        },
        userUser: {
          /*
            "fullName": "string",
            "id": 0,
            "role": "string",
            "username": "string"
          */
          value: {
            fullName: "Add New User",
            id: -1
          },
          // isLoaded: false,
          // isValid: null,
          // isRequired: true,
          // options: [{
          //   fullName: "Add New User",
          //   id: -1
          // }],
          // currentPage: 1,
          // perPage: 10,
          // totalRows: 0,
          // totalPages: 0,
          // lastQuery: '',
          // payloadKey: "userId"
        },
        userFullName: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "userFullName"
        },
        userName: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "username"
        },
        userPword: {
          value: '',
          isValid: null,
          isRequired: true,
          feedback: 'This input is required.',
          payloadKey: "password"
        },
        userCPword: {
          value: '',
          isValid: null
        },
        // userJobCode: {
        //   /*
        //     "jobCode": "string",
        //     "jobName": "string",
        //     "roleId": 0,
        //     "roleName": "string"
        //   */
        //   value: '',
        //   isLoaded: false,
        //   isValid: null,
        //   isRequired: true,
        //   options: [],
        //   currentPage: 1,
        //   perPage: 10,
        //   totalRows: 0,
        //   totalPages: 0,
        //   lastQuery: '',
        //   payloadKey: "code"
        // },
        // vendorBank: {
        //   value: '',
        //   payloadKey: "vendorBank"
        // },
        // vendorBankAccount: {
        //   value: '',
        //   payloadKey: "vendorBankAccount"
        // },
        // vendorName: {
        //   value: '',
        //   payloadKey: "vendorName"
        // },
        // vendorStatus: {
        //   value: '',
        //   payloadKey: "vendorStatus"
        // },
      }
    }
  },
  methods: {

    // testAction() {
    //   console.warn(this.formData.notaryCity)
    // },

    onInputCity() {
      this.populateZipcode()
      if (!this.$helper.isEmpty(this.formData.notaryCity.value)) {
        // City selected
        if (!this.$helper.isEmpty(this.formData.notaryZip.value)) {
          // Zipcode is already selected
          if (!this.checkZipcode()) {
            // Selected zipcode doesn't aligns with the city
            this.formData.notaryZip.value = null
          }
        }
      } else{
        // City is deselected
        this.formData.notaryZip.value = null
      }

      if (this.citySelectedfromZipcode) {
        // Remove the first element of option
        this.formData.notaryCity.options.shift()
        this.citySelectedfromZipcode = false
      }
    },

    onInputZipcode() {
      if (!this.$helper.isEmpty(this.formData.notaryZip.value) && this.$helper.isEmpty(this.formData.notaryCity.value)) {
        // Zipcode selected but city is still empty
        // Automatically assign city based on zipcode
        let obj = {
          code: this.formData.notaryZip.value.cityCode,
          name: this.formData.notaryZip.value.cityName,
        }
        this.formData.notaryCity.value = obj
        if (this.citySelectedfromZipcode) {
          // City is already selected previously
          this.formData.notaryCity.options[0] = obj
        } else{
          // City has not been specified through zipcode 
          this.formData.notaryCity.options.unshift(obj)
          this.citySelectedfromZipcode = true
        }
      }
    },

    checkZipcode() {
      if (this.formData.notaryCity.value.code == this.formData.notaryZip.value.cityCode) {
        return true
      } else{
        return false
      }
    },

    appendZipcode() {
      this.formData.notaryZip.isLoaded = false
      // URL builder
      let getUrl = "/zipcode/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.formData.notaryZip.currentPage, this.formData.notaryZip.perPage)
      if(this.formData.notaryZip.lastQuery !== ""){
        params['filterType'] = "zipcode"
        params['filterValue'] = this.formData.notaryZip.lastQuery
      }
      if (!this.$helper.isEmpty(this.formData.notaryCity.value)) {
        params['filterCity'] = this.formData.notaryCity.value.code
      }
      params['asc'] = "true"
      params['sortBy'] = "zipcode"

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            for(let i = 0; i < response.data.data.data.length; i++){
              let obj = {
                ...response.data.data.data[i],
                code: response.data.data.data[i].zipcode,
                name: response.data.data.data[i].zipcode
              }
              this.formData.notaryZip.options.push(obj)
            }
            this.formData.notaryZip.currentPage++
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kode Pos Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Kode Pos Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kode Pos Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.formData.notaryZip.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    populateZipcode(query = "") {
      this.formData.notaryZip.isLoaded = false
      this.formData.notaryZip.totalPages = 0
      this.formData.notaryZip.totalRows = 0
      this.formData.notaryZip.currentPage = 1
      this.formData.notaryZip.lastQuery = query
      // URL builder
      let getUrl = "/zipcode/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.formData.notaryZip.currentPage - 1, this.formData.notaryZip.perPage)
      if(query !== ""){
        params['filterType'] = "zipcode"
        params['filterValue'] = query
      }
      if (!this.$helper.isEmpty(this.formData.notaryCity.value)) {
        params['filterCity'] = this.formData.notaryCity.value.code
      }
      params['asc'] = "true"
      params['sortBy'] = "zipcode"

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.formData.notaryZip.options = []
            for(let i = 0; i < response.data.data.data.length; i++){
              let obj = {
                ...response.data.data.data[i],
                code: response.data.data.data[i].zipcode,
                name: response.data.data.data[i].zipcode
              }
              this.formData.notaryZip.options.push(obj)
            }
            this.formData.notaryZip.totalRows = response.data.data.totalElements
            this.formData.notaryZip.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kode Pos Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Kode Pos Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kode Pos Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.formData.notaryZip.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    appendCity() {
      this.formData.notaryCity.isLoaded = false
      // URL builder
      let getUrl = "/city/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.formData.notaryCity.currentPage, this.formData.notaryCity.perPage)
      if(this.formData.notaryCity.lastQuery !== ""){
        params['filterType'] = "name"
        params['filterValue'] = this.formData.notaryCity.lastQuery
      }
      params['asc'] = "true"
      params['sortBy'] = "name"

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            for(let i = 0; i < response.data.data.data.length; i++){
              if (!this.$helper.objectHasSameData(response.data.data.data[i], this.formData.notaryCity.value)) {
                this.formData.notaryCity.options.push(response.data.data.data[i])
              }
            }
            this.formData.notaryCity.currentPage++
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kota Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Kota Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kota Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.formData.notaryCity.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    populateCity(query = "") {
      this.formData.notaryCity.isLoaded = false
      this.formData.notaryCity.totalPages = 0
      this.formData.notaryCity.totalRows = 0
      this.formData.notaryCity.currentPage = 1
      this.formData.notaryCity.lastQuery = query
      // URL builder
      let getUrl = "/city/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.formData.notaryCity.currentPage - 1, this.formData.notaryCity.perPage)
      if(query !== ""){
        params['filterType'] = "name"
        params['filterValue'] = query
      }
      params['asc'] = "true"
      params['sortBy'] = "name"

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.formData.notaryCity.options = []
            if (!this.$helper.isEmpty(this.formData.notaryCity.value)) this.formData.notaryCity.options.push(this.formData.notaryCity.value)
            for(let i = 0; i < response.data.data.data.length; i++){
              if (!this.$helper.objectHasSameData(response.data.data.data[i], this.formData.notaryCity.value)) {
                this.formData.notaryCity.options.push(response.data.data.data[i])
              }
            }
            this.formData.notaryCity.totalRows = response.data.data.totalElements
            this.formData.notaryCity.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kota Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Kota Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kota Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.formData.notaryCity.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    // update datepicker valid dates on change
    onContextSkbValidFrom() {
      this.formData.skbValidTo.minValue = this.formData.skbValidFrom.value
    },
    onContextSkbValidTo() {
      this.formData.skbValidFrom.maxValue = this.formData.skbValidTo.value
    },
    // for updating specific input elements on change
    updateKey(keyName){
      return keyName + "-" + this.keyIncrement++
    },
    // clearFormVendor() {
    //   this.formData.vendorBank.value = ''
    //   this.formData.vendorBankAccount.value = ''
    //   this.formData.vendorName.value = ''
    //   this.formData.vendorStatus.value = ''
    //   this.formData.vendorId.isValid = null
    // },
    // // validate vendor ID button functionality
    // validateVendorId() {
    //   let postUrl = '/notary/checkVendorId'
    //   let payload = new FormData()
    //   payload.append("vendorId", this.formData.vendorId.value)
    //   // only send axios request if role is valid
    //   if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
    //     this.formData.vendorId.isChecking = true
    //     this.$axios.post(postUrl, payload).then(response => {
    //       if(response.status == 200){
    //         this.formData.vendorBank.value = response.data.data.bank
    //         this.formData.vendorBankAccount.value = response.data.data.noRek
    //         this.formData.vendorName.value = response.data.data.namaVendor
    //         this.formData.vendorStatus.value = response.data.data.statusRek
    //         this.formData.vendorId.isValid = true
    //       }
    //       else{
    //         this.formData.vendorId.feedback = "Vendor ID tidak valid! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : "Unknown Error")
    //         this.formData.vendorId.isValid = false
    //       }
    //     })
    //     .catch(error => {
    //       if(!this.$helper.isEmpty(error.response)){
    //         this.formData.vendorId.feedback = "Vendor ID tidak valid! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found")
    //       }
    //       else{
    //         this.formData.vendorId.feedback = "Vendor ID tidak valid! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error")
    //       }
    //       this.formData.vendorId.isValid = false
    //     })
    //     .finally(() => {
    //       this.formData.vendorId.isChecking = false
    //     })
    //   }
    //   else {
    //     this.formData.vendorId.feedback = "Access Denied!"
    //     this.formData.vendorId.isValid = false
    //   }
    // },
    // clear user form on selecting an existing user
    clearUser(){
      this.formData.userFullName.value = ''
      // this.formData.userJobCode.value = ''
      this.formData.userName.value = ''
      this.formData.userPword.value = ''
      this.formData.userCPword.value = ''
      this.formData.userFullName.isValid = null
      // this.formData.userJobCode.isValid = null
      this.formData.userName.isValid = null
      this.formData.userPword.isValid = null
      this.formData.userCPword.isValid = null
    },
    // clear skb date form on selecting no skb
    // clearSkbDate(){
    //   this.formData.skbValidFrom.value = ''
    //   this.formData.skbValidTo.value = ''
    //   this.formData.skbValidFrom.isValid = null
    //   this.formData.skbValidTo.isValid = null
    // },
    // // populate select office dropdown dynamically
    // populateSelectOffice(query = "") {
    //   this.formData.office.isLoaded = false
    //   this.formData.office.totalPages = 0
    //   this.formData.office.totalRows = 0
    //   this.formData.office.currentPage = 1
    //   this.formData.office.lastQuery = query
    //   // URL builder
    //   let getUrl = "/office/getAll"
    //   // get content from current page
    //   getUrl += "?page=" + (this.formData.office.currentPage - 1)
    //   getUrl += "&size=" + this.formData.office.perPage
    //   if(query !== ""){
    //     getUrl += "&filterType=nameFull"
    //     getUrl += "&filterValue=" + query
    //   }
    //   // only send axios request if role is valid
    //   if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
    //     this.$axios.get(getUrl).then(response => {
    //       if(response.status == 200){
    //         this.formData.office.options = []
    //         for(let i = 0; i < response.data.data.data.length; i++){
    //           this.formData.office.options.push(response.data.data.data[i])
    //         }
    //         this.formData.office.totalRows = response.data.data.totalElements
    //         this.formData.office.totalPages = response.data.data.totalPages
    //       }
    //       else{
    //         this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
    //       }
    //     })
    //     .catch(error => {
    //       if(!this.$helper.isEmpty(error.response)){
    //         this.$helper.toastError(this, "Load Daftar Office Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
    //       }
    //       else{
    //         this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
    //       }
    //     })
    //     .finally(() => {
    //       this.formData.office.isLoaded = true
    //     })
    //   }
    //   else{
    //     this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
    //   }
    // },
    // // load more options for select office dropdown dynamically
    // appendSelectOffice() {
    //   this.formData.office.isLoaded = false
    //   // URL builder
    //   let getUrl = "/office/getAll"
    //   // get content from next page
    //   getUrl += "?page=" + (this.formData.office.currentPage)
    //   getUrl += "&size=" + this.formData.office.perPage
    //   if(this.formData.office.lastQuery !== ""){
    //     getUrl += "&filterType=nameFull"
    //     getUrl += "&filterValue=" + this.formData.office.lastQuery
    //   }
    //   // only send axios request if role is valid
    //   if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
    //     this.$axios.get(getUrl).then(response => {
    //       if(response.status == 200){
    //         for(let i = 0; i < response.data.data.data.length; i++){
    //           this.formData.office.options.push(response.data.data.data[i])
    //         }
    //         this.formData.office.currentPage++
    //       }
    //       else{
    //         this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
    //       }
    //     })
    //     .catch(error => {
    //       if(!this.$helper.isEmpty(error.response)){
    //         this.$helper.toastError(this, "Load Daftar Office Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
    //       }
    //       else{
    //         this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
    //       }
    //     })
    //     .finally(() => {
    //       this.formData.office.isLoaded = true
    //     })
    //   }
    //   else{
    //     this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
    //   }
    // },
    // // populate select user dropdown dynamically
    // populateSelectUser(query = "") {
    //   this.formData.userUser.isLoaded = false
    //   this.formData.userUser.totalPages = 0
    //   this.formData.userUser.totalRows = 0
    //   this.formData.userUser.currentPage = 1
    //   this.formData.userUser.lastQuery = query
    //   // URL builder
    //   let getUrl = "/user/getAllNotaryUser"
    //   // get content from current page
    //   getUrl += "?page=" + (this.formData.userUser.currentPage - 1)
    //   getUrl += "&size=" + this.formData.userUser.perPage
    //   if(query !== ""){
    //     getUrl += "&filterType=fullName"
    //     getUrl += "&filterValue=" + query
    //   }
    //   // only send axios request if role is valid
    //   if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
    //     this.$axios.get(getUrl).then(response => {
    //       if(response.status == 200){
    //         this.formData.userUser.options = [{
    //           fullName: "Add New User",
    //           id: -1
    //         }]
    //         for(let i = 0; i < response.data.data.data.length; i++){
    //           this.formData.userUser.options.push(response.data.data.data[i])
    //         }
    //         this.formData.userUser.totalRows = response.data.data.totalElements
    //         this.formData.userUser.totalPages = response.data.data.totalPages
    //       }
    //       else{
    //         this.$helper.toastError(this, "Load Daftar User Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
    //       }
    //     })
    //     .catch(error => {
    //       if(!this.$helper.isEmpty(error.response)){
    //         this.$helper.toastError(this, "Load Daftar User Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
    //       }
    //       else{
    //         this.$helper.toastError(this, "Load Daftar User Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
    //       }
    //     })
    //     .finally(() => {
    //       this.formData.userUser.isLoaded = true
    //     })
    //   }
    //   else{
    //     this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
    //   }
    // },
    // // load more options for select user dropdown dynamically
    // appendSelectUser() {
    //   this.formData.userUser.isLoaded = false
    //   // URL builder
    //   let getUrl = "/user/getAllNotaryUser"
    //   // get content from next page
    //   getUrl += "?page=" + (this.formData.userUser.currentPage)
    //   getUrl += "&size=" + this.formData.userUser.perPage
    //   if(this.formData.userUser.lastQuery !== ""){
    //     getUrl += "&filterType=fullName"
    //     getUrl += "&filterValue=" + this.formData.userUser.lastQuery
    //   }
    //   // only send axios request if role is valid
    //   if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
    //     this.$axios.get(getUrl).then(response => {
    //       if(response.status == 200){
    //         for(let i = 0; i < response.data.data.data.length; i++){
    //           this.formData.userUser.options.push(response.data.data.data[i])
    //         }
    //         this.formData.userUser.currentPage++
    //       }
    //       else{
    //         this.$helper.toastError(this, "Load Daftar User Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
    //       }
    //     })
    //     .catch(error => {
    //       if(!this.$helper.isEmpty(error.response)){
    //         this.$helper.toastError(this, "Load Daftar User Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
    //       }
    //       else{
    //         this.$helper.toastError(this, "Load Daftar User Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
    //       }
    //     })
    //     .finally(() => {
    //       this.formData.userUser.isLoaded = true
    //     })
    //   }
    //   else{
    //     this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
    //   }
    // },
    // // populate select jobcode dropdown dynamically
    // populateSelectJobCode(query = "") {
    //   this.formData.userJobCode.isLoaded = false
    //   this.formData.userJobCode.totalPages = 0
    //   this.formData.userJobCode.totalRows = 0
    //   this.formData.userJobCode.currentPage = 1
    //   this.formData.userJobCode.lastQuery = query
    //   // URL builder
    //   let getUrl = "/jobCode/getAll"
    //   // get content from current page
    //   getUrl += "?page=" + (this.formData.userJobCode.currentPage - 1)
    //   getUrl += "&size=" + this.formData.userJobCode.perPage
    //   if(query !== ""){
    //     getUrl += "&filterType=jobName"
    //     getUrl += "&filterValue=" + query
    //   }
    //   // only send axios request if role is valid
    //   if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
    //     this.$axios.get(getUrl).then(response => {
    //       if(response.status == 200){
    //         this.formData.userJobCode.options = []
    //         for(let i = 0; i < response.data.data.data.length; i++){
    //           this.formData.userJobCode.options.push(response.data.data.data[i])
    //         }
    //         this.formData.userJobCode.totalRows = response.data.data.totalElements
    //         this.formData.userJobCode.totalPages = response.data.data.totalPages
    //       }
    //       else{
    //         this.$helper.toastError(this, "Load Daftar Job Code Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
    //       }
    //     })
    //     .catch(error => {
    //       if(!this.$helper.isEmpty(error.response)){
    //         this.$helper.toastError(this, "Load Daftar Job Code Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
    //       }
    //       else{
    //         this.$helper.toastError(this, "Load Daftar Job Code Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
    //       }
    //     })
    //     .finally(() => {
    //       this.formData.userJobCode.isLoaded = true
    //     })
    //   }
    //   else{
    //     this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
    //   }
    // },
    // // load more options for select jobcode dropdown dynamically
    // appendSelectJobCode() {
    //   this.formData.userJobCode.isLoaded = false
    //   // URL builder
    //   let getUrl = "/jobCode/getAll"
    //   // get content from next page
    //   getUrl += "?page=" + (this.formData.userJobCode.currentPage)
    //   getUrl += "&size=" + this.formData.userJobCode.perPage
    //   if(this.formData.userJobCode.lastQuery !== ""){
    //     getUrl += "&filterType=jobName"
    //     getUrl += "&filterValue=" + this.formData.userJobCode.lastQuery
    //   }
    //   // only send axios request if role is valid
    //   if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
    //     this.$axios.get(getUrl).then(response => {
    //       if(response.status == 200){
    //         for(let i = 0; i < response.data.data.data.length; i++){
    //           this.formData.userJobCode.options.push(response.data.data.data[i])
    //         }
    //         this.formData.userJobCode.currentPage++
    //       }
    //       else{
    //         this.$helper.toastError(this, "Load Daftar Job Code Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
    //       }
    //     })
    //     .catch(error => {
    //       if(!this.$helper.isEmpty(error.response)){
    //         this.$helper.toastError(this, "Load Daftar Job Code Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
    //       }
    //       else{
    //         this.$helper.toastError(this, "Load Daftar Job Code Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
    //       }
    //     })
    //     .finally(() => {
    //       this.formData.userJobCode.isLoaded = true
    //     })
    //   }
    //   else{
    //     this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
    //   }
    // },
    createNotary(event) {
      event.preventDefault()
      // validate form entries before submit
      let isFormValid = true
      let obj = {}
      for(const [key, data] of Object.entries(this.formData)){
        // check user password
        if(key == "userPword"){
          if (data.isRequired && this.$helper.isEmpty(data.value)) {
            data.feedback = "This input is required."
            isFormValid = false
            data.isValid = false
          } else if (data.value.length < 8) {
            data.feedback = "Password should contain a minimal 8 characters."
            isFormValid = false
            data.isValid = false
          } else if (!this.$helper.containsSmallLetter(data.value) || !this.$helper.containsCapitalLetter(data.value)) {
            data.feedback = "Password should contain small [a-z] and capital [A-Z] letter."
            isFormValid = false
            data.isValid = false
          } else if (!this.$helper.containsNumber(data.value)) {
            data.feedback = "Password should contain number [0-9]."
            isFormValid = false
            data.isValid = false
          } else if (!this.$helper.containsSpecialCharacter(data.value)) {
            data.feedback = "Password should contain special character [ `!@#$%^&*()_+-=[]{};':\"|,.<>/?~ ]."
            isFormValid = false
            data.isValid = false
          } else{
            data.isValid = null
          }
        }
        // recheck user password
        else if(key == "userCPword"){
          if(this.$helper.isEmpty(data.value)){
            data.isValid = false
            isFormValid = false
          }
          else if(data.value != this.formData.userPword.value){
            data.isValid = false
            isFormValid = false
          }
          else{
            data.isValid = null
          }
        }
        // // check Vendor ID field
        // else if(key == "vendorId"){
        //   if(data.isValid){
        //     obj[data.payloadKey] = data.value
        //   }
        //   else if(data.isRequired){
        //     data.feedback = "Please check Vendor ID validity."
        //     data.isValid = false
        //     isFormValid = false
        //   }
        //   else{
        //     data.isValid = null
        //   }
        // }
        // check multiselect fields
        else if(key == "type"){
          if(!this.$helper.isEmpty(data.value)){
            data.isValid = null
            obj[data.payloadKey] = data.value.value
          }
          else if(data.isRequired){
            data.isValid = false
            isFormValid = false
          }
          else{
            data.isValid = null
          }
        }
        // else if(key == "office"){
        //   if(!this.$helper.isEmpty(data.value)){
        //     data.isValid = null
        //     obj[data.payloadKey] = data.value.officeCode
        //   }
        //   else if(data.isRequired){
        //     data.isValid = false
        //     isFormValid = false
        //   }
        //   else{
        //     data.isValid = null
        //   }
        // }
        else if(key == "skb"){
          if(!this.$helper.isEmpty(data.value)){
            data.isValid = null
            obj[data.payloadKey] = data.value.value
          }
          else if(data.isRequired){
            data.isValid = false
            isFormValid = false
          }
          else{
            data.isValid = null
          }
        }
        else if(key == "ppn"){
          if(!this.$helper.isEmpty(data.value)){
            data.isValid = null
            obj[data.payloadKey] = data.value.value
          }
          else if(data.isRequired){
            data.isValid = false
            isFormValid = false
          }
          else{
            data.isValid = null
          }
        }
        // else if(key == "userUser"){
        //   if(!this.$helper.isEmpty(data.value)){
        //     data.isValid = null
        //     // append payload with new user boolean
        //     if(data.value.id == -1){
        //       obj["newUser"] = true
        //     }
        //     else{
        //       obj["newUser"] = false
        //       obj[data.payloadKey] = data.value.id
        //     }
        //   }
        //   else if(data.isRequired){
        //     data.isValid = false
        //     isFormValid = false
        //   }
        //   else{
        //     data.isValid = null
        //   }
        // }
        else if(key == "userJobCode"){
          if(this.formData.userUser.value.id == -1){
            if(!this.$helper.isEmpty(data.value)){
              data.isValid = null
              obj[data.payloadKey] = data.value.jobCode
            }
            else if(data.isRequired){
              data.isValid = false
              isFormValid = false
            }
            else{
              data.isValid = null
            }
          }
          else{
            data.isValid = null
          }
        }
        // check and mirror SKB Date fields if SKB is enabled
        else if(key == "skbValidFrom" || key == "skbValidTo"){
          if(!this.formData.skb.value.value){
            if(!this.$helper.isEmpty(this.formData.skbValidFrom.value) && !this.$helper.isEmpty(this.formData.skbValidTo.value)){
              data.isValid = null
              obj[data.payloadKey] = data.value
            }
            else if(this.formData.skbValidFrom.isRequired || this.formData.skbValidTo.isRequired){
              this.formData.skbValidFrom.isValid = false
              this.formData.skbValidTo.isValid = false
              isFormValid = false
            }
            else{
              data.isValid = null
            }
          }
          else{
            data.isValid = null
          }
        }
        // check user fields if Add New User is selected
        else if(key == "userFullName" || key == "userJobCode" || key == "userName" || key == "userPword"){
          if(this.formData.userUser.value.id == -1){
            if(!this.$helper.isEmpty(data.value)){
              data.isValid = null
              obj[data.payloadKey] = data.value
            }
            else if(data.isRequired){
              data.isValid = false
              isFormValid = false
            }
            else{
              data.isValid = null
            }
          }
          else{
            data.isValid = null
          }
        }
        else if(key == "notaryEmail"){
          if(!this.$helper.isEmpty(data.value)){
            if(!data.format.test(data.value)){
              data.feedback = 'Please enter a valid email format.'
              data.isValid = false
              isFormValid = false
            }
            else{
              data.isValid = null
              obj[data.payloadKey] = data.value
            }
          }
          else if(data.isRequired){
            data.feedback = 'This input is required.'
            data.isValid = false
            isFormValid = false
          }
          else{
            data.isValid = null
          }
        }
        else if(key == "notaryCity") {
          if(this.$helper.isEmpty(data.value) && data.isRequired){
            data.feedback = 'This input is required.'
            data.isValid = false
            isFormValid = false
          } else{
            obj[data.payloadKey] = data.value.name
            data.isValid = null
          }
        }
        else if(key == "notaryZip") {
          if(this.$helper.isEmpty(data.value) && data.isRequired){
            data.feedback = 'This input is required.'
            data.isValid = false
            isFormValid = false
          } else{
            obj[data.payloadKey] = data.value.code
            data.isValid = null
          }
        }
        // // check additional vendor data
        // else if(key == "vendorBank" || key == "vendorBankAccount" || key == "vendorName" || key == "vendorStatus"){
        //   if(!this.$helper.isEmpty(data.value)){
        //     obj[data.payloadKey] = data.value
        //   }
        //   else{
        //     this.formData.vendorId.isValid = false
        //     isFormValid = false
        //   }
        // }
        // check remaining fields
        else{
          if(!this.$helper.isEmpty(data.value)){
            data.isValid = null
            obj[data.payloadKey] = data.value
          }
          else if(data.isRequired){
            data.isValid = false
            isFormValid = false
          }
          else{
            data.isValid = null
          }
        }
      }
      // submit form data if every field is valid
      if(isFormValid){
        let postUrl = '/notary/add/'
        obj.password = this.formData.userPword.value
        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
          this.isSubmitting = true
          this.$axios.post(postUrl, obj).then(response => {
            if(response.status == 200){
              // if(this.formData.userUser.value.id == -1){
              //   this.clearUser()
              //   // this.populateSelectUser()
              // }
              this.$helper.toastSuccess(this.$root, "Create Notaris Berhasil!")
              // this.$router.push({ name: 'Notaris List' })
            }
            else{
              this.$helper.toastError(this, "Create Notaris Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
            }
          })
          .catch(error => {
            if(!this.$helper.isEmpty(error.response)){
              this.$helper.toastError(this, "Create Notaris Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
            }
            else{
              this.$helper.toastError(this, "Create Notaris Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
            }
          })
          .finally(() => {
            this.isSubmitting = false
          })
        }
        else{
          this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
        }
      }
    }
  },
  computed: {
  },
  async mounted() {
    // // populate all select dropdowns on page load
    // this.populateSelectOffice()
    // this.populateSelectUser()
    // this.populateSelectJobCode()
    await this.populateCity()
    await this.populateZipcode()
  },
  created(){
  }
}
</script>

<style>

</style>
